// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"87":"5cf17f80","384":"83fcbee6","511":"d1bd276f","703":"83fcbee6","988":"a8d6038f"}[chunkId] + ".chunk.css";
};